import { NoteTypeAndScope, dashboard } from 'types';
import { core } from '@tock/coretypes';
import { filter, orderBy } from 'es-toolkit/compat';

export const PATRON_NOTE_SCOPE_TO_TYPE_TO_TITLE: {
  [key in dashboard.NoteScope]: { [key in dashboard.NoteType]: string };
} = {
  BUSINESS: {
    DIETARY: 'Dietary Notes',
    GENERAL: 'Guest Notes',
  },
  BUSINESS_GROUP: {
    DIETARY: 'Group Dietary Notes',
    GENERAL: 'Group Guest Notes',
  },
};

const NOTE_SCOPE_TYPES: NoteTypeAndScope[] = Object.keys(
  PATRON_NOTE_SCOPE_TO_TYPE_TO_TITLE
).flatMap((key) => {
  const scope = key as dashboard.NoteScope;
  return Object.keys(PATRON_NOTE_SCOPE_TO_TYPE_TO_TITLE[scope]).map((innerKey) => ({
    scope,
    type: innerKey as dashboard.NoteType,
  }));
});

export function getActivePatronNoteScopeTypes(
  isFeatureEnabled: (featureFlag: core.Feature.FeatureName) => boolean
): NoteTypeAndScope[] {
  const useGroupDietaryNote = isFeatureEnabled('GROUP_LEVEL_DIETARY_NOTES');

  const activeNoteScopeTypes: NoteTypeAndScope[] = filter(NOTE_SCOPE_TYPES, ({ scope, type }) => {
    const isBusinessScope = scope === 'BUSINESS';
    const isGroupScope = scope === 'BUSINESS_GROUP';
    const isGeneralNote = type === 'GENERAL';
    const isDietaryNote = type === 'DIETARY';
    if (isGroupScope && isGeneralNote) {
      return false;
    }
    if (useGroupDietaryNote && isBusinessScope && isDietaryNote) {
      return false;
    }
    if (!useGroupDietaryNote && isGroupScope && isDietaryNote) {
      return false;
    }
    return true;
  });
  return orderBy(activeNoteScopeTypes, ['scope', 'type'], ['asc', 'desc']);
}
